import { Component , OnInit } from '@angular/core';
import {Router} from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'CellDeRetailToolApp';

  constructor(private router:Router){

  }
  ngOnInit(){
    
    window.addEventListener('storage', (event) => {
      
      if (event.storageArea == sessionStorage) {
        let token = sessionStorage.getItem("user");
        if(token == undefined) { // you can update this as per your key
            // DO LOGOUT FROM THIS TAB AS WELL
            this.router.navigate(['/']); // If you are using router
            // OR
            //window.location.href = '<home page URL>';
        }
        /*else{
          this.router.navigate(['/enterprise']); // If you are using router
        }*/
      }
    }, false);
  }

}
